import { useState, useEffect, useCallback, useContext } from 'react';
import { useHttpClient } from './http-hook';
import { AuthContext } from '../context/auth-context';

const useKnowledgeBases = () => {
    const [knowledgeBases, setKnowledgeBases] = useState([]);
    const [userOrganizations, setUserOrganizations] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const { isLoading, error, sendRequest } = useHttpClient();
    const auth = useContext(AuthContext);

    const fetchKnowledgeBases = useCallback(async () => {
        try {
            const response = await sendRequest('/api/knowledgebases');
            const knowledgeBasesArray = response?.data || [];
            setKnowledgeBases(knowledgeBasesArray);
        } catch (err) {
            console.error('Error fetching knowledge bases:', err);
            setKnowledgeBases([]); // Set empty array on error
        }
    }, [sendRequest]);

    useEffect(() => {
        fetchKnowledgeBases();
    }, [fetchKnowledgeBases]);

    const fetchUserOrganizations = useCallback(async () => {
        try {
            let organizations = [];

            if (auth.isSuperAdmin) {
                const response = await sendRequest(
                    "/api/organizations",
                    "GET",
                    null,
                    {
                        Authorization: "Bearer " + auth.token,
                    }
                );
                organizations = response.data;
            } else {
                organizations = auth.memberships;
            }

            setUserOrganizations(organizations);

            setShowDropdown(auth.isSuperAdmin || organizations.length > 1);
        } catch (err) {
            console.error("Error fetching organizations:", err);
        }
    }, [sendRequest, auth.token, auth.isSuperAdmin, auth.memberships]);

    const createKnowledgeBase = useCallback(
        async (knowledgeBaseData) => {
            console.log('Creating knowledge base:', knowledgeBaseData);
            try {
                const response = await sendRequest(
                    '/api/knowledgebases',
                    'POST',
                    JSON.stringify(knowledgeBaseData),
                    {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + auth.token,
                    }
                );
                return response.data;
            } catch (err) {
                console.error('Error creating knowledge base:', err);
                throw err;
            }
        },
        [sendRequest, auth.token]
    );

    const updateKnowledgeBase = useCallback(
        async (knowledgeBaseId, knowledgeBaseData) => {
            console.log('Updating knowledge base:', knowledgeBaseId, knowledgeBaseData);
            try {
                const response = await sendRequest(
                    `/api/knowledgebases/${knowledgeBaseId}`,
                    'PUT',
                    JSON.stringify(knowledgeBaseData),
                    {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + auth.token,
                    }
                );
                return response.data;
            } catch (err) {
                console.error('Error updating knowledge base:', err);
                throw err;
            }
        },
        [sendRequest, auth.token]
    );


    return {
        knowledgeBases,
        isLoading,
        error,
        fetchKnowledgeBases,
        createKnowledgeBase,
        updateKnowledgeBase,
        fetchUserOrganizations,
        showDropdown,
        userOrganizations
    };
};

export default useKnowledgeBases;